// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFundOutlinedSvg from "@fishx/icons-svg/es/asn/PFundOutlined";
import FishxIcon from '../components/FishxIcon';

var PFundOutlined = function PFundOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFundOutlinedSvg
  }));
};

PFundOutlined.displayName = 'PFundOutlined';
export default React.forwardRef(PFundOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFundOutlined.js
// module id = 3440
// module chunks = 0